module.exports = __webpack_public_path__ + "static/media/404.041084a6.svg";